export default __webpack_public_path__ + "static/media/Emotion_Fear.45675761.svg";